import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

import MapInfoWindowNearestLocalsLocal from './MapInfoWindowNearestLocalsLocal';

export default ({ locals, onSelectNearLocal }) => (
  <NearestLocals>
    <Title>
      Farmacias sugeridas
    </Title>

    {locals.length > 0 ? (
      <>
        {locals.map((nearLocal) => (
          <MapInfoWindowNearestLocalsLocal
            key={nearLocal.local}
            local={nearLocal}
            onSelectNearLocal={onSelectNearLocal}
          />
        ))}
        <Message>
          Distancias respecto a local
        </Message>
      </>
    ) : (
      <MessageNoNearLocals>
        Lo sentimos,
        no hay farmacias cercanas abiertas.
      </MessageNoNearLocals>
    )}
  </NearestLocals>
);

const NearestLocals = styled.div`
  ${tw`mt-4`}
`;

const Title = styled.div`
  color: #00953B;
  ${tw`uppercase font-bold text-center`}

  &:before, &:after {
    content: '';
    background-color: #00953B; 
    ${tw`h-px w-5 bg-green inline-block my-1 mx-4`}
  }
`;

const MessageNoNearLocals = styled.p`
  ${tw`text-gray-800 text-xs text-center my-6`}
`;

const Message = styled.p`
  ${tw`text-gray-600 text-xs text-center mb-0`}
`;
